module.exports = __webpack_public_path__ + "img/Bell_02.0e8b3f64.png";